import { render, staticRenderFns } from "./siGoodsList.vue?vue&type=template&id=2ae03985&scoped=true&"
import script from "./siGoodsList.vue?vue&type=script&lang=js&"
export * from "./siGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./siGoodsList.vue?vue&type=style&index=0&id=2ae03985&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae03985",
  null
  
)

component.options.__file = "siGoodsList.vue"
export default component.exports